<div>
  <mat-dialog-content>
    <mat-radio-group>
      @for (filterCriteria of filterCriterias; track filterCriteria) {
        @if (!filterCriteria.hidden && filterCriteria.type && !filterCriteria.excludeInFilter) {
          <div class="list-p-m">
            <ng-container>
              <mat-radio-button color="primary" [value]="filterCriteria.columnName || filterCriteria.id" (change)="getValue(filterCriteria)" >
              {{filterCriteria.columnDisplayValue || filterCriteria.name }}</mat-radio-button>
            </ng-container>
          </div>
        }
        @if (filterCriteria.excludeInFilter && filterCriteria.id == 'UserActivityLogActivityDetails' && filterCriteria.columnName == 'activityDetail') {
          <span class="info-message">{{ filterInfoMessage }}</span>
        }
      }
    </mat-radio-group>

    @if (selectedFilter.type === ClindxTableFilterType.inputType && labelName !== null) {
      <mat-form-field>
        <input matInput placeholder="{{labelName}}" [(ngModel)]="filterValue" name="filterText"
          maxlength="{{selectedFilter.maxLength}}" (ngModelChange)="checkValue($event)" autocomplete="new-password">
        </mat-form-field>
      }

      @if (selectedFilter.type === ClindxTableFilterType.numberType && labelName !== null) {
        <mat-form-field>
          <input matInput numbersOnly placeholder="{{labelName}}" oninput="this.value=this.value.slice(0,this.maxLength)"
            [(ngModel)]="filterValue" name="filterText"
            maxlength="{{selectedFilter.maxLength}}" (ngModelChange)="checkValue($event)" autocomplete="off">
          </mat-form-field>
        }


        @if (selectedFilter.type === ClindxTableFilterType.inputTypeWithMinLength && labelName !== null) {
          <mat-form-field>
            <input matInput placeholder="{{labelName}}" [(ngModel)]="filterValue" name="filterText"
              maxlength="{{selectedFilter.maxLength}}" (ngModelChange)="checkValue($event)" autocomplete="new-password" minlength = "{{selectedFilter.minLength}}">
            </mat-form-field>
          }

          @if (selectedFilter.type === ClindxTableFilterType.enumType  && !selectedFilter.isMulti) {
            <mat-form-field>
              <mat-label>{{labelName}}</mat-label>
              <mat-select [(ngModel)]="filterValue" name="status" (ngModelChange)="checkValue($event)">
                @for (status of selectedFilter.args; track status) {
                  <mat-option [value]="status.value">
                    {{status.name}}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          }

          @if (selectedFilter.type === ClindxTableFilterType.enumType  && selectedFilter.isMulti === true) {
            <mat-form-field>
              <mat-label>{{labelName}}</mat-label>
              <mat-select [(ngModel)]="filterValue" name="status" (ngModelChange)="checkValue($event)" multiple>
                @for (status of selectedFilter.args; track status) {
                  <mat-option [value]="status.value">
                    {{status.name}}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          }

          <mat-form-field fxShow="{{selectedFilter.type === ClindxTableFilterType.dateWithValidationType}}" hideRequiredMarker
            class="p-b-20">
            <input matInput #input="ngModel" placeholder="{{selectedFilter.placeHolder}}" [min]="minDateforDob"
              [max]="maxDateForDOB" [matDatepicker]="picker1" [(ngModel)]="filterValue" (ngModelChange)="checkValue(input)"
              autocomplete="new-password" required>
              <mat-datepicker #picker1 disabled="false"> </mat-datepicker>
              <mat-datepicker-toggle matSuffix [for]="picker1" disabled="false"></mat-datepicker-toggle>
              @if (input.hasError('matDatepickerParse') && (input.dirty || input.touched)) {
                <mat-error>
                {{ValidationMessages.Invaliddatevalidation}}</mat-error>
              }
              @if (input.hasError('matDatepickerMax') && (input.dirty || input.touched)) {
                <mat-error>
                {{ValidationMessages.MaxDateValidation}}</mat-error>
              }
            </mat-form-field>

            @if (selectedFilter.type === ClindxTableFilterType.dateRangeType) {
              <mat-form-field class="calendar-width">
                <mat-label>Select Date Range</mat-label>
                <mat-date-range-input [formGroup]="dateRangeForm" [rangePicker]="reportedOnRangePicker" [min]="minDate.toDate()" [max]="maxDate.toDate()">
                  <input matStartDate formControlName="start" placeholder="Start date" (dateChange)="onDateChanged()">
                  <input matEndDate formControlName="end" placeholder="End date" (dateChange)="onDateChanged()">
                </mat-date-range-input>
                <mat-datepicker-toggle matIconSuffix [for]="reportedOnRangePicker"></mat-datepicker-toggle>
                <mat-date-range-picker #reportedOnRangePicker (closed)="onPickerClosed()">
                  <mat-datepicker-actions>
                    <app-date-range
                      [beginDate]="dateRangeForm.get('start')?.value"
                      [endDate]="dateRangeForm.get('end')?.value"
                      (rangeSelected)="onQuickRangeSelected($event)">
                    </app-date-range>
                    <button mat-button matDatepickerCancel>Cancel</button>
                    <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                  </mat-datepicker-actions>
                </mat-date-range-picker>
              </mat-form-field>
            }

            @if (selectedFilter.type === ClindxTableFilterType.dateType) {
              <mat-form-field>
                <mat-label>Select Date Range</mat-label>
                <mat-date-range-input [formGroup]="dateRangeForm" [rangePicker]="dateRangePicker">
                  <input matStartDate formControlName="start" placeholder="Start date" (dateChange)="onDateChanged()">
                  <input matEndDate formControlName="end" placeholder="End date" (dateChange)="onDateChanged()">
                </mat-date-range-input>
                <mat-datepicker-toggle matIconSuffix [for]="dateRangePicker"></mat-datepicker-toggle>
                <mat-date-range-picker #dateRangePicker (closed)="onPickerClosed()">
                  <mat-datepicker-actions>
                    <app-date-range
                      [beginDate]="dateRangeForm.get('start')?.value"
                      [endDate]="dateRangeForm.get('end')?.value"
                      (rangeSelected)="onQuickRangeSelected($event)">
                    </app-date-range>
                    <button mat-button matDatepickerCancel>Cancel</button>
                    <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                  </mat-datepicker-actions>
                </mat-date-range-picker>
              </mat-form-field>
            }
          </mat-dialog-content>
          <mat-dialog-actions [ngClass]="{'m-t-65':labelName==null}" fxLayout="row" fxLayoutAlign="end center">
            <button mat-button color="primary" [disabled]="applyDisabilityCheck()" (click)="applyFilter()">Apply</button>
          </mat-dialog-actions>
        </div>
